var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.filename))]),_c('div',{staticClass:"progress"},[_c('Progress',{attrs:{"percentage":_vm.percentage,"state":_vm.uploadState}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }